var map = {
	"./analyse-1.png": 642,
	"./analyse-2.png": 807,
	"./anglais-1.png": 220,
	"./anglais-2.png": 611,
	"./architecture-1.png": 507,
	"./architecture-2.png": 280,
	"./default.png": 865,
	"./lpl-1.png": 581,
	"./lpl-2.png": 897,
	"./poo-1.png": 419,
	"./poo-2.png": 567,
	"./sda-1.png": 295,
	"./sda-2.png": 901,
	"./tech-dev-1.png": 86,
	"./tech-dev-2.png": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;